var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import Feedback from '../feedback/feedback';
import styled from 'styled-components';
import { Color, Size, FontWeight, BreakPoint } from '../const/index';
import { fadeIn } from '../mixin/animation';
import Button from '../button/button';
import ScrollLock from '../feedback/scroll-lock';
import { verticalHorizontalCentering } from '../mixin/mixin';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderActionButtons = function () {
            var _a = _this.props, isConfirm = _a.isConfirm, onClose = _a.onClose, onResolve = _a.onResolve, actions = _a.actions;
            if (!actions) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(LeftAction, null),
                    React.createElement(RightAction, null,
                        isConfirm && React.createElement(Button, { onClick: onClose }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                        React.createElement(Button, { primary: true, onClick: onResolve || onClose }, "OK"))));
            }
            else if (actions.length === 3) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(LeftAction, null,
                        React.createElement(Button, __assign({}, actions[0]), actions[0].text)),
                    React.createElement(RightAction, { shouldHaveMargin: true }, actions
                        .filter(function (_, i) { return i !== 0; })
                        .map(function (_a, i) {
                        var text = _a.text, props = __rest(_a, ["text"]);
                        return (React.createElement(Button, __assign({ key: i }, props), text));
                    }))));
            }
            else {
                return (React.createElement(React.Fragment, null,
                    React.createElement(LeftAction, null),
                    React.createElement(RightAction, null, actions.map(function (_a, i) {
                        var text = _a.text, props = __rest(_a, ["text"]);
                        return (React.createElement(Button, __assign({ key: i }, props), text));
                    }))));
            }
        };
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, CustomScrollLock = _a.CustomScrollLock;
        return (React.createElement(Feedback, { onClose: this.props.onClose, overlay: this.props.overlay },
            React.createElement(StyledDialog, __assign({}, this.props),
                React.createElement(Content, null,
                    title && React.createElement(Title, null, title),
                    children,
                    CustomScrollLock && React.createElement(CustomScrollLock, null)),
                React.createElement(Footer, null, this.renderActionButtons()))));
    };
    Dialog.defaultProps = {
        isConfirm: false,
        CustomScrollLock: ScrollLock,
    };
    return Dialog;
}(React.Component));
export default Dialog;
var StyledDialog = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  animation: ", " 0.5s forwards ease-in-out;\n  background: ", ";\n  border-radius: 8px;\n  box-sizing: border-box;\n  color: ", ";\n  max-height: calc(100% - 64px);\n  width: 480px;\n  ", ";\n\n  @media (max-width: ", ") {\n    width: 90%;\n  }\n"], ["\n  animation: ", " 0.5s forwards ease-in-out;\n  background: ", ";\n  border-radius: 8px;\n  box-sizing: border-box;\n  color: ", ";\n  max-height: calc(100% - 64px);\n  width: 480px;\n  ", ";\n\n  @media (max-width: ", ") {\n    width: 90%;\n  }\n"])), fadeIn, Color.WHITE, Color.VERY_DARK_GRAY, verticalHorizontalCentering, BreakPoint.spMax);
var Title = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 20px;\n  font-weight: ", ";\n  margin-bottom: 12px;\n"], ["\n  font-size: 20px;\n  font-weight: ", ";\n  margin-bottom: 12px;\n"])), FontWeight.BOLD);
var LeftAction = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    width: 100%;\n    button {\n      width: 100%;\n      margin: 0;\n    }\n  }\n"], ["\n  @media (max-width: ", ") {\n    width: 100%;\n    button {\n      width: 100%;\n      margin: 0;\n    }\n  }\n"])), BreakPoint.spMax);
var RightAction = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  button + button {\n    margin: 0 0 0 8px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    width: 100%;\n\n    button + button {\n      margin: 0 0 8px 0;\n    }\n\n    ", " + & {\n      margin-bottom: ", ";\n    }\n\n    button {\n      width: 100%;\n      margin: 0;\n    }\n  }\n"], ["\n  display: flex;\n  button + button {\n    margin: 0 0 0 8px;\n  }\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    width: 100%;\n\n    button + button {\n      margin: 0 0 8px 0;\n    }\n\n    ", " + & {\n      margin-bottom: ", ";\n    }\n\n    button {\n      width: 100%;\n      margin: 0;\n    }\n  }\n"])), BreakPoint.spMax, LeftAction, function (props) { return (props.shouldHaveMargin ? '32px' : 0); });
var Footer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  padding: 0 28px 12px 28px;\n  justify-content: space-between;\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    padding: 0 12px 12px 12px;\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-shrink: 0;\n  padding: 0 28px 12px 28px;\n  justify-content: space-between;\n\n  @media (max-width: ", ") {\n    flex-direction: column-reverse;\n    padding: 0 12px 12px 12px;\n  }\n"])), BreakPoint.spMax);
var Content = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-bottom: 16px;\n  padding: 28px 28px 0 28px;\n  position: relative;\n  white-space: pre-wrap;\n\n  @media (max-width: ", ") {\n    padding: 28px 12px 0 12px;\n  }\n"], ["\n  flex: 1;\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-bottom: 16px;\n  padding: 28px 28px 0 28px;\n  position: relative;\n  white-space: pre-wrap;\n\n  @media (max-width: ", ") {\n    padding: 28px 12px 0 12px;\n  }\n"])), Size.FONT.BASE, FontWeight.NORMAL, BreakPoint.spMax);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=dialog.js.map